// extracted by mini-css-extract-plugin
export var component = "layout-module--component--o2NH7";
export var componentWidthFull = "layout-module--component-width-full--2S3Kh";
export var componentWidthNarrow = "layout-module--component-width-narrow--NuZkz";